import clsx from "clsx";
import { twMerge } from "tailwind-merge";

interface CardSurfaceProps extends React.ComponentProps<"div"> {}

export function CardSurface({ className, children, ...props }: CardSurfaceProps) {
  return (
    <div
      className={clsx(
        "w-full p-4 sm:p-6 bg-white overflow-hidden rounded-lg",
        "border border-neutral-200 dark:border-neutral-800",
        "shadow-md shadow-blue-950/10",
        "dark:bg-neutral-900 dark:shadow-black/30",
        className,
      )}
      {...props}
    >
      {children}
    </div>
  );
}

interface AppSurfaceProps extends React.ComponentProps<"div"> {}

export function AppSurface({ className, children, ...props }: AppSurfaceProps) {
  return (
    <div
      className={clsx(
        "w-full p-6 sm:p-10 bg-white overflow-hidden rounded-2xl",
        "shadow-xl shadow-blue-950/10",
        "dark:bg-neutral-900 dark:shadow-black/30",
        className,
      )}
      {...props}
    >
      {children}
    </div>
  );
}

interface PaneSurfaceProps extends React.ComponentProps<"div"> {}

export function PaneSurface({ children, className, ...props }: PaneSurfaceProps) {
  return (
    <div
      className={twMerge(
        clsx(
          "p-10 shadow-2xl shadow-black/15 border border-neutral-200 rounded-lg",
          "bg-white dark:bg-neutral-900 dark:shadow-black/30 dark:border-neutral-800",
        ),
        className,
      )}
      {...props}
    >
      {children}
    </div>
  );
}
